import { getStorageData } from '../../functions.any';
import { MAP_COLLABORATION_LANG_TO_COUNTRY_CODE, MAP_CONTINENT_CODE_TO_COUNTRY_CODE } from './constants';
export function getDialInObjectByLang(numbersWithGeo = {}) {
    const { phoneNumbers, geo } = numbersWithGeo;
    if (!phoneNumbers) {
        return null;
    }
    const keys = Object.keys(phoneNumbers);
    if (!keys.length) {
        return null;
    }
    const geoLocale = geo?.pbxCountryIsoCode?.toLowerCase();
    const geoContinent = geo?.pbxContinentCode;
    const collaborationLanguage = getStorageData('collaborationLanguage');
    const geoLocaleByContinentCode = MAP_CONTINENT_CODE_TO_COUNTRY_CODE[geoContinent];
    const defaultLocale = 'gb';
    const [fallbackLocale] = keys;
    let dialInObject = phoneNumbers[geoLocale]
        || phoneNumbers[geoLocaleByContinentCode]
        || phoneNumbers[defaultLocale]
        || phoneNumbers[fallbackLocale];
    if (collaborationLanguage) {
        const collaborationLocale = MAP_COLLABORATION_LANG_TO_COUNTRY_CODE[collaborationLanguage]
            || collaborationLanguage;
        dialInObject = phoneNumbers[geoLocale]
            || phoneNumbers[collaborationLocale]
            || phoneNumbers[defaultLocale]
            || phoneNumbers[fallbackLocale];
    }
    return dialInObject;
}
export function getPhoneNumberByLangWildix(numbersWithGeo = {}) {
    const dialInObject = getDialInObjectByLang(numbersWithGeo);
    const [resultNumber = null] = dialInObject?.phones || [];
    return resultNumber;
}
